import { createFileRoute } from '@tanstack/react-router'
import { LegalNoticePage } from '_/features/legal/ui/legal-page'

export const Route = createFileRoute('/legal')({
	staticData: { title: 'legal_notice_title' },
	component: LegalNoticePage,
})
